import { apiSlice } from "@/app/api/apiSlice";
import { urlConfig } from "@/config";

export const rateAlertSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getRateAlerts: build.query<any, void>({
      query: () => `${urlConfig.rateAlertUrl}/rate-alerts/`,
      providesTags: ["RateAlerts"],
    }),
    getRateAlertById: build.query<any, string>({
      query: (id) => `${urlConfig.rateAlertUrl}/rate-alerts/${id}/`,
      providesTags: (result, error, id) => [{ type: "RateAlerts", id }],
    }),
    createRateAlert: build.mutation({
      query: (body) => ({
        url: `${urlConfig.rateAlertUrl}/rate-alerts/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["RateAlerts"],
    }),
    updateRateAlert: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${urlConfig.rateAlertUrl}/rate-alerts/${id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["RateAlerts"],
    }),
    deleteRateAlert: build.mutation<any, { id: string }>({
      query: ({ id }) => ({
        url: `${urlConfig.rateAlertUrl}/rate-alerts/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["RateAlerts"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetRateAlertsQuery,
  useGetRateAlertByIdQuery,
  useCreateRateAlertMutation,
  useUpdateRateAlertMutation,
  useDeleteRateAlertMutation,
} = rateAlertSlice;
